import { axiosInstance } from "../client";
import { Concept } from "@rumble-it/common-lib/types/models/Concept.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";

interface ConceptFilterParams {
  dossierTypeName: string;
}

export interface ConceptQueryParams
  extends PaginationParams,
    ConceptFilterParams {}

export const fetchConcepts = async (
  params: ConceptQueryParams,
): Promise<CollectionResponse<Concept>> =>
  axiosInstance
    .get("/admin/dossiers/concept", { params })
    .then((response) => response.data);

export const fetchConceptById = async (id: string): Promise<Concept> =>
  axiosInstance
    .get(`/admin/dossiers/concept/${id}`)
    .then((response) => response.data);

export const deleteConceptById = async (id: string): Promise<Concept> =>
  axiosInstance
    .delete(`/admin/dossiers/concept/${id}`)
    .then((response) => response.data);

export const createConcept = async (
  data: Record<string, any>,
): Promise<Concept> =>
  axiosInstance
    .post(`/admin/dossiers/concept`, data)
    .then((response) => response.data);

export const createConceptInvite = async (
  data: Record<string, any>,
): Promise<Concept> =>
  axiosInstance
    .post(`/admin/dossiers/concept-invite`, data)
    .then((response) => response.data);
